export default __webpack_public_path__ + "static/media/media-video.a8505e6c.svg";